/**
 * The CSV behind the Funnel tab's download: the same counts the tables show,
 * in the same order, one flat sheet. The weekly totals come first (breakdown
 * "all"), then each breakdown's rows. Pure: no DOM, no clock.
 */

import type { IntakeFunnelReportWire } from '@/lib/api';

export const FUNNEL_CSV_HEADER = [
  'breakdown',
  'week_start',
  'week_end',
  'partial',
  'value',
  'inquiries',
  'converted',
  'waiting',
  'turned_away',
] as const;

/** Quote a cell when it carries a comma, a quote, or a line break. */
function csvCell(value: string | number | boolean): string {
  const text = String(value);
  if (/[",\r\n]/.test(text)) return `"${text.replace(/"/g, '""')}"`;
  return text;
}

function line(cells: ReadonlyArray<string | number | boolean>): string {
  return cells.map(csvCell).join(',');
}

export function buildFunnelCsv(report: IntakeFunnelReportWire): string {
  const weekEndByStart = new Map(report.by_week.map((w) => [w.week_start, w]));
  const lines: string[] = [line(FUNNEL_CSV_HEADER)];
  for (const w of report.by_week) {
    lines.push(line(['all', w.week_start, w.week_end, w.is_partial, 'All', w.inquiries, w.converted, w.waiting, w.turned_away]));
  }
  for (const b of report.breakdowns) {
    for (const r of b.rows) {
      const week = weekEndByStart.get(r.week_start);
      lines.push(
        line([
          b.dimension,
          r.week_start,
          week?.week_end ?? '',
          week?.is_partial ?? false,
          r.label,
          r.inquiries,
          r.converted,
          r.waiting,
          r.turned_away,
        ]),
      );
    }
  }
  return `${lines.join('\r\n')}\r\n`;
}

/** intake-funnel-12w-YYYY-MM-DD.csv, dated from the report's generated_at. */
export function funnelCsvFilename(report: IntakeFunnelReportWire): string {
  return `intake-funnel-${report.weeks}w-${report.generated_at.slice(0, 10)}.csv`;
}
